<div>
  <div style="padding-top: 10vh" *ngIf="loading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  <div class="row mb-3" *ngIf="!loading">
    <div class="col-sm-12  col-md-3 col-lg-3">
      <input class="form-control" mdbInput type="text" placeholder="Search By Opportunity Name" [(ngModel)]="searchText"
             (ngModelChange)="search()">
    </div>

  </div>
  <div style="background-color: whitesmoke" *ngIf="!loading">


    <div style="background-color: #54B4D3;color: white" class="p-2">
      <h2>PJM </h2>
    </div>

    <div class="p-2">
      <table class="table table-striped table-hover">
        <thead>
        <th>Opportunity Name</th>
        <th>Utility</th>
        <th>Start Date</th>
        <th>Account Number(s)</th>
        <th>First Request Date</th>
        <th>Refresh Date</th>
        </thead>
        <tbody>
        <tr *ngFor="let row of priceHistoryPjmList | slice: (page1-1) * pageSize1 : page1 * pageSize1  "
            (click)="openPriceDetail(row)">
          <td> {{row.opportunityName}}</td>
          <td> {{row.utility}}</td>
          <td> {{row.startDate }}</td>
          <td> {{formatAccountNumbers(row.accountNumbers)  }}</td>
          <td> {{row.requestedDate | date:'MM/dd/yy h:mm:ss a'  }}</td>
          <td> {{row.refreshDate  | date:'MM/dd/yy h:mm:ss a' }}</td>
        </tr>
        </tbody>
      </table>
      <ngb-pagination *ngIf="priceHistoryPjmList.length > 0"
                      [(page)]="page1"
                      [pageSize]="pageSize1"
                      [collectionSize]="priceHistoryPjmList.length"
                      [maxSize]="maxSizeOfPages" [boundaryLinks]="enableBoundaryLink"></ngb-pagination>

    </div>
  </div>
  <div style="background-color: whitesmoke" class="mt-5" *ngIf="!loading">
    <div style="background-color: #54B4D3;color: white" class="p-2">
      <h2>ERCOT </h2>
    </div>

    <div class="p-2">
      <table class="table table-striped table-hover">
        <thead>
        <th>Opportunity Name</th>
        <th>Utility</th>
        <th>Start Date</th>
        <th>Zone</th>
        <th>Load Type</th>
        <th>kWh / Year</th>
        <th>First Request Date</th>
        <th>Refresh Date</th>
        </thead>
        <tbody>
        <tr *ngFor="let row of priceHistoryErcotList | slice: (page2-1) * pageSize2 : page2 * pageSize2 "
            (click)="openPriceDetail(row)">
          <td> {{row.opportunityName}}</td>
          <td> {{row.utility}}</td>
          <td> {{row.startDate  }}</td>
          <td> {{row.zone}}</td>
          <td> {{row.loadType}}</td>
          <td> {{row.kwhYear}}</td>
          <td> {{row.requestedDate | date:'MM/dd/yy h:mm:ss a'  }}</td>
          <td> {{row.refreshDate  | date:'MM/dd/yy h:mm:ss a' }}</td>
        </tr>
        </tbody>
      </table>
      <ngb-pagination *ngIf="priceHistoryErcotList.length > 0"
                      [(page)]="page2"
                      [pageSize]="pageSize2"
                      [collectionSize]="priceHistoryErcotList.length"
                      [maxSize]="maxSizeOfPages" [boundaryLinks]="enableBoundaryLink"></ngb-pagination>
    </div>
    <p class="mt-5 pl-2 pb-3">
      Your price request history will only display opportunities with a refresh date within the past 60 days and with future start month.
    </p>
  </div>


</div>
